import TrailNames from "../../constants/TrailNames";
import circleTrailInfo from "./circleTrail/circleTrail";

const allTrails = {
    [TrailNames.CIRCLE_TRAIL] : circleTrailInfo,
}

export default allTrails;